define(function (require) {
    var avalon = require('avalon'),
        ajax = require('ajax'),
        dialog = require('dialog'),
        tool = require('toolLoaderPC'),
        $ = require('jquery'),
        piczoom = require('piczoom'),
        WebUploader = require('webuploader'),
        saveUrl,
        _csrf;

    var hiddenValues, globleValues;

    var vmodel = avalon.define({
        $id: 'evaluateController',

        type: '', // Y => 评价， N => 查看评价
        goods: [],

        anonymous: [], // 匿名

        changeScore: function (el, i) {
            if (vmodel.type == 'N') {
                return;
            }
            el.score = i;
        },

        checkTag: function (el, tagId) {
            var tags = el.tags,
                isTag = false;
            for (var i = 0; i < tags.length; i++) {
                if (tags[i] == tagId) {
                    isTag = true;
                    break;
                }
            }
            return isTag;
        },

        selectTag: function (el, tagId) {
            if (vmodel.type == 'N') {
                return;
            }
            var tags = el.tags,
                isTag = false;
            for (var i = 0; i < tags.length; i++) {
                if (tags[i] == tagId) {
                    isTag = true;
                    break;
                }
            }
            if (isTag) {
                el.tags.remove(tagId);
            } else {
                el.tags.push(tagId);
            }
        },

        initUpload: function () {
            var fileMaxSize = 1024 * 1024 * 2;
            // 扩展webupload对象
            $.extend(WebUploader.Uploader.options, {
                // 选完文件后，是否自动上传。
                auto: true,
                swf:
                    globleValues.frontUrl +
                    '/frontcommon_assets/swf/Uploader.swf',
                server: hiddenValues.upload,
                accept: {
                    title: 'Images',
                    extensions: 'gif,jpg,jpeg,bmp,png',
                    mimeTypes: 'image/gif,image/jpg,image/jpeg,image/png'
                },
                fileVal: 'thefile',
                fileSingleSizeLimit: fileMaxSize,
                duplicate: true
            });
            for (var i = 0; i < vmodel.goods.length; i++) {
                // 初始化Web Uploader
                (function (i) {
                    var uploader = WebUploader.create({
                        pick: '.filePicker' + vmodel.goods[i].goods_id
                    });
                    uploader.on('uploadSuccess', function (file, response) {
                        if (response.type === 'succ') {
                            vmodel.goods[i].album.push(response.msg.fileurl);
                        } else {
                            dialog.alert(response.msg);
                        }
                    });
                    uploader.on('beforeFileQueued', function (file) {
                        if (file.size > fileMaxSize) {
                            dialog.alert('文件大小超过2M限制');
                            return false;
                        } else if (vmodel.goods[i].album.length >= 5) {
                            dialog.alert('最多上传5张图片');
                            return false;
                        }
                    });
                })(i);
            }
        },

        openImg: function (el, index) {
            piczoom.show(el, index);
        },

        submitClick: function () {
            var sendData = {
                order_id: hiddenValues.order_id,
                anonymous: vmodel.anonymous.indexOf('1') != -1 ? 1 : 0,
                _csrf: _csrf,
                evaluate: []
            };

            for (var i = 0; i < vmodel.goods.length; i++) {
                if (vmodel.goods[i].score <= 0) {
                    return dialog.alert('还有商品没有评分哦！');
                } else {
                    sendData.evaluate.push({
                        GoodsEvaluate: {
                            sku_id: vmodel.goods[i].sku_id,
                            score: vmodel.goods[i].score,
                            content: vmodel.goods[i].content,
                            album: vmodel.goods[i].album,
                            tags: vmodel.goods[i].tags
                        }
                    });
                }
            }

            tool.singleWay('mall-evaluate', function (key) {
                var kit = this;
                ajax
                    .postWithFail(saveUrl, sendData)
                    .done(function (response) {
                        kit.resolve(key);
                        if (response.type === 'succ') {
                            ajax.pjax(response.url);
                        }
                    })
                    .fail(function () {
                        kit.resolve(key);
                    });
            });
        },

        deleteImagesClick: function (el, img) {
            el.album.remove(img);
        }
    });

    function buildGoods (arr) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].evaluate && arr[i].evaluate.score) {
                arr[i].tags = [];
                for (var j = 0; j < arr[i].tag_list.length; j++) {
                    if (arr[i].tag_list[j].selected == 1) {
                        arr[i].tags.push(arr[i].tag_list[j].tag_id);
                    }
                }
                arr[i].score = parseInt(arr[i].evaluate.score);
                arr[i].album = arr[i].evaluate.album;
                arr[i].content = arr[i].evaluate.content;
            } else {
                arr[i].tags = [];
                arr[i].score = 0;
                arr[i].album = [];
                arr[i].content = [];
            }
        }
        return arr;
    }

    return {
        init: function () {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            globleValues = tool.getHiddenValues('#js-hiddens');

            vmodel.goods = buildGoods(hiddenValues.orders.data);
            vmodel.type = hiddenValues.orders.type;
            saveUrl = hiddenValues.url;
            _csrf = hiddenValues._csrf;

            piczoom.init();
        },
        clear: function () {}
    };
});



// WEBPACK FOOTER //
// ./src/js_modules/evaluateController.js